import { render, staticRenderFns } from "./PackageModal.vue?vue&type=template&id=273ebc55&scoped=true&"
import script from "./PackageModal.vue?vue&type=script&lang=js&"
export * from "./PackageModal.vue?vue&type=script&lang=js&"
import style0 from "./PackageModal.vue?vue&type=style&index=0&id=273ebc55&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273ebc55",
  null
  
)

export default component.exports